import { getSocialNetwork } from './social-network-tracking.mjs';

const pushTrackingEvent = (payload) => {
    window.corimTracking?.push(payload);
};

const getClosestLink = (target, selector) => {
    if (!(target instanceof Element)) {
        return null;
    }

    return target.closest(selector);
};

const initializeCtaTracking = () => {
    document.addEventListener('click', (event) => {
        const cta = getClosestLink(event.target, '.cta-contact-corim');
        if (cta) {
            pushTrackingEvent({
                event: 'click_main_cta',
                cta_name: cta.dataset.ctaLabel || cta.textContent.trim(),
                cta_position: cta.dataset.ctaPosition || cta.closest('[id]')?.id || 'unknown',
                cta_page: window.location.pathname,
            });

            return;
        }

        const telephoneLink = getClosestLink(event.target, 'a[href^="tel:"]');
        if (telephoneLink) {
            pushTrackingEvent({
                event: 'click_tel',
                cta_name: telephoneLink.dataset.ctaLabel || 'telephone',
                cta_page: window.location.pathname,
            });

            return;
        }

        const socialLink = getClosestLink(event.target, 'a[href]');
        const socialNetwork = socialLink
            ? socialLink.dataset.corimSocialNetwork || getSocialNetwork(socialLink.href, window.location.href)
            : null;
        if (socialNetwork) {
            pushTrackingEvent({
                event: 'click_social_network',
                social_network: socialNetwork,
                social_position: socialLink.closest('footer') ? 'footer' : 'menu',
                social_page: window.location.pathname,
            });
        }
    });

    const sectorFilter = document.querySelector('#sectorFilter');
    if (sectorFilter) {
        sectorFilter.addEventListener('change', () => {
            const selected = sectorFilter.value;
            document.querySelectorAll('div[data-sectors]').forEach((element) => {
                const sectors = element.dataset.sectors.split(', ');
                element.hidden = selected !== '' && !sectors.includes(selected);
            });
        });
    }
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCtaTracking, { once: true });
} else {
    initializeCtaTracking();
}
